<template>
  <div class="home__feature-list">
    <div>
      <home-feature-item
        :color="'#d9374a'"
        :background="'#f9ebed'"
        :icon="'heart'"
        :title="'Inspiration statt Aspirin'"
        :text="'Von Wellness bis Wissen. Wählen Sie aus 6 unterschiedlichen Themen Ihr persönliches Weinerlebnis.'"
      ></home-feature-item>
      <home-feature-item
        :color="'#6d0b9b'"
        :background="'#f1e4f6'"
        :icon="'watch'"
        :title="'Weinreisen für enge Zeitpläne'"
        :text="'Freitags nach der Arbeit los und Montags wieder im Büro? Klar! Gönnen Sie sich einfach mal eine Auszeit zwischendurch.'"
      ></home-feature-item>
      <home-feature-item
        :color="'#f8b020'"
        :background="'#fef6e7'"
        :icon="'award'"
        :title="'Exklusive Weingüter'"
        :text="'Lernen Sie bei einem Glas Wein die Winzer, ihre Geschichten und ihre Schatzkammern kennen.'"
      ></home-feature-item>
    </div>
  </div>
</template>

<script>
import HomeFeatureItem from "./HomeFeatureItem.vue";

export default {
  name: "HomeFeatureList",
  data() {
    return {
      active: 0
    };
  },
  props: {
    msg: String
  },
  components: {
    HomeFeatureItem
  }
};
</script>

<style scoped lang="scss">
.home__feature-list {
  background-color: #ffffff;
  padding: 80px 16px;

  > div {
    max-width: 1056px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: auto;
  }
}

.heart-icon {
  color: #d9374a;
}

.watch-icon {
  color: #6d0b9b;
}

.award-icon {
  color: #f8b020;
}

@media (max-width: 1023px) {
  .home__feature-list {
    > div {
      flex-direction: column;
      max-width: 320px;
    }
  }
}

@media (max-width: 767px) {
  .home__feature-list {
  padding: 64px 24px 32px;

  }
}
</style>
